import React, { useState, useEffect } from "react";
import { ButtonGroup, Dropdown, Spinner } from "react-bootstrap";
import { useQuery } from "react-query";
import { debounce } from "lodash";
import {
  CRUDLayout,
  Table,
  THead,
  TBody,
  ThFixed,
  TdFixed,
  Tr,
  Th,
  Td,
  Pagination,
  Alert,
} from "components";
import {
  InputSearch,
  DataStatus,
  ButtonFilter,
  ButtonDetail,
} from "components2";
import { tableNumber } from "utilities2";
import { ModalDetail, ModalFilter } from "./TransferBahanProduksiAsetComps";
import TransferBahanProduksiAsetApi from "./TransferBahanProduksiAsetApi";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { Formik } from "formik";
import { DateConvert, DecimalConvert } from "utilities";

export const TransferBahanProduksiAsetList = ({ setNavbarTitle }) => {
  const { state } = useLocation();

  const [alertConfig, setAlertConfig] = useState({
    show: false,
    text: "",
    variant: "primary",
  });

  const [filter, setFilter] = useState({
    q: "",
    page: 1,
    per_page: 10,
    tgl_transfer_produksi_aset_bahan_mulai: undefined,
    tgl_transfer_produksi_aset_bahan_selesai: undefined,
    tgl_permintaan_produksi_aset_bahan_mulai: undefined,
    tgl_permintaan_produksi_aset_bahan_selesai: undefined,
    id_gudang_tujuan: undefined,
    id_gudang_asal: undefined,
    id_item_bahan: undefined,
    active: false,
  });

  const [modalFilter, setModalFilter] = useState(false);
  const [modalDetailConfig, setModalDetailConfig] = useState({
    data: {},
    show: false,
  });

  const getPermintaanAset = useQuery(
    ["analisa_checklist", "list", filter],
    () => TransferBahanProduksiAsetApi.getList(filter)
  );

  const searchHandler = (e) => {
    const searchKey = e.target.value ? e.target.value : undefined;

    setFilter({
      ...filter,
      q: searchKey,
    });
    setAlertConfig({
      show: searchKey ? true : false,
      variant: "primary",
      text: "Hasil dari pencarian: " + searchKey,
    });
  };

  const onFilterButtonClickkHandler = () => setModalFilter(!modalFilter);

  console.log(modalFilter);

  const onPaginationChange = ({ selected }) =>
    setFilter({ ...filter, page: selected + 1 });

  const onPaginationDataLengthChange = (e) =>
    setFilter({ ...filter, page: 1, per_page: e.target.value });

  const checkAlert = () => {
    if (state) {
      if (state.alert) {
        setAlertConfig({
          show: state?.alert?.show,
          text: state?.alert?.text,
          variant: state?.alert?.variant,
        });
      }
    }
  };

  // FORM VALUES FILTER
  const formInitialValuesFilter = {
    tgl_transfer_produksi_aset_bahan_mulai:
      filter?.tgl_transfer_produksi_aset_bahan_mulai,
    tgl_transfer_produksi_aset_bahan_selesai:
      filter?.tgl_transfer_produksi_aset_bahan_selesai,
    tgl_permintaan_produksi_aset_bahan_mulai:
      filter?.tgl_permintaan_produksi_aset_bahan_mulai,
    tgl_permintaan_produksi_aset_bahan_selesai:
      filter?.tgl_permintaan_produksi_aset_bahan_selesai,
    id_gudang_tujuan: filter?.id_gudang_tujuan,
    id_gudang_asal: filter?.id_gudang_asal,
    id_item_bahan: filter?.id_item_bahan,
  };

  const formSubmitHandlerFilter = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    setFilter({
      ...filter,
      ...values,
      active: checkActive,
      page: 1,
    });
    onFilterButtonClickkHandler();
  };

  useEffect(() => {
    setNavbarTitle("Transfer Bahan Produksi Aset");
    checkAlert();
  }, []);

  return (
    <CRUDLayout>
      <CRUDLayout.Head>
        <CRUDLayout.HeadSearchSection>
          <div className="d-flex mb-3">
            <InputSearch
              onChange={debounce(searchHandler, 700)}
              className="mr-2"
            />
            <ButtonFilter
              size="sm"
              className="text-nowrap"
              onClick={onFilterButtonClickkHandler}
              active={filter?.active}
            />
          </div>
        </CRUDLayout.HeadSearchSection>
        <CRUDLayout.HeadButtonSection></CRUDLayout.HeadButtonSection>
      </CRUDLayout.Head>

      {getPermintaanAset.isLoading || getPermintaanAset.isError ? (
        <DataStatus
          loading={getPermintaanAset.isLoading}
          text={
            getPermintaanAset.isLoading ? "Memuat . . ." : "Data gagal dimuat"
          }
        />
      ) : (
        <>
          <Alert
            show={alertConfig?.show}
            text={alertConfig?.text}
            variant={alertConfig?.variant}
            showCloseButton
            onClose={() =>
              setAlertConfig({
                ...alertConfig,
                show: false,
              })
            }
          />
          <div className="mt-2">
            <small className="font-weight-bold">
              List Data Transfer Bahan Produksi Aset
            </small>
          </div>
          <Table>
            <THead>
              <Tr>
                <ThFixed>No.</ThFixed>
                <ThFixed>Aksi</ThFixed>
                <ThFixed>Informasi Transfer Bahan Produksi Aset</ThFixed>
                <ThFixed>Informasi Permintaan Produksi Aset</ThFixed>
                <Th>Item Bahan</Th>
                <Th>Qty. Transfer</Th>
                <Th>Gudang Asal</Th>
                <Th>Gudang Tujuan</Th>
              </Tr>
            </THead>
            <TBody>
              {getPermintaanAset?.data?.data?.length > 0 ? (
                getPermintaanAset?.data?.data?.map((e, index) => (
                  <Tr key={index}>
                    <TdFixed>
                      {tableNumber({
                        pageCurrent: filter.page,
                        dataLength: filter.per_page,
                        index,
                      })}
                    </TdFixed>
                    <TdFixed>
                      <ButtonGroup>
                        <ButtonDetail
                          icon
                          noText
                          variant="primary"
                          onClick={() =>
                            setModalDetailConfig({ data: e, show: true })
                          }
                        />
                      </ButtonGroup>
                    </TdFixed>
                    <Td>
                      <div>
                        {e?.tgl_transfer_produksi_aset_bahan
                          ? DateConvert(
                              new Date(e?.tgl_transfer_produksi_aset_bahan)
                            ).custom
                          : "-"}
                      </div>
                      <div>{e?.no_transfer_produksi_aset_bahan ?? "-"}</div>
                    </Td>
                    <Td>
                      <div>
                        {e?.tgl_permintaan_produksi_aset_bahan
                          ? DateConvert(
                              new Date(e?.tgl_permintaan_produksi_aset_bahan)
                            ).custom
                          : "-"}
                      </div>
                      <div>{e?.no_permintaan_produksi_aset_bahan ?? "-"}</div>
                    </Td>
                    <Td>{e?.nama_item ?? "-"}</Td>
                    <Td className="text-right">
                      {`${
                        DecimalConvert(parseFloat(e?.qty_transfer ?? 0))
                          .getWithComa
                      } ${e?.nama_satuan ?? "-"}`}
                    </Td>
                    <Td>{e?.nama_gudang_asal ?? "-"}</Td>
                    <Td>{e?.nama_gudang_tujuan ?? "-"}</Td>
                  </Tr>
                ))
              ) : (
                <Tr>
                  <Td colSpan={8}>
                    <DataStatus text="Tidak ada data" />
                  </Td>
                </Tr>
              )}
            </TBody>
          </Table>
          <Pagination
            dataLength={filter?.per_page}
            dataNumber={filter?.page * filter?.per_page - filter?.per_page + 1}
            dataPage={
              filter?.dataCount < filter?.per_page
                ? filter?.dataCount
                : filter?.page * filter?.per_page
            }
            dataCount={getPermintaanAset?.data?.data_count}
            currentPage={filter?.page}
            totalPage={getPermintaanAset?.data?.total_page}
            onPaginationChange={onPaginationChange}
            onDataLengthChange={onPaginationDataLengthChange}
          />
        </>
      )}

      {modalDetailConfig?.show && (
        <ModalDetail
          setModalConfig={setModalDetailConfig}
          modalConfig={modalDetailConfig}
        />
      )}

      {modalFilter && (
        <Formik
          enableReinitialize
          initialValues={formInitialValuesFilter}
          onSubmit={formSubmitHandlerFilter}
        >
          <ModalFilter toggle={onFilterButtonClickkHandler} />
        </Formik>
      )}
    </CRUDLayout>
  );
};
